import React from 'react';
import {LightBulbIcon} from '@heroicons/react/24/outline';
import {videoPromo} from 'assets';

interface IAcceptInviteWhoAreWeProps {}

const AcceptInviteWhoAreWe = ({}: IAcceptInviteWhoAreWeProps) => {
  return (
    <div className="relative max-w-2xl w-full flex flex-col sm:flex-row gap-5 bg-white dark:bg-slate-900 border border-slate-300 shadow-sm rounded-md p-4">
      <div className="flex flex-col gap-5">
        <div className="flex items-center gap-2">
          <LightBulbIcon className="size-5 text-orange-600 dark:text-yellow-500" />
          <h2 className="dark:text-white text-xl font-bold">What's DasAR?</h2>
        </div>
        <p className="dark:text-darkText">
          DasAR is a no-code web-based Augmented Reality solution for business - revolutionising the way customers connect with your brand through AR.
        </p>
        <a href="https://das-ar.com" target="_blank" rel="noreferrer noopener" className="text-primary underline sm:no-underline hover:underline">
          Learn more
        </a>
      </div>
      <video src={videoPromo} loop autoPlay muted width={200} height={200} className="w-full sm:w-54 aspect-square rounded-md" />
    </div>
  );
};

export default React.memo(AcceptInviteWhoAreWe);
